/** @format */

export function removeTimezone(date: Date) {
  if (date.getHours() * 60 !== -date.getTimezoneOffset()) {
    date.setMinutes(-date.getTimezoneOffset() - date.getHours() * 60);
  }
}

export function dateStringToJsonUtc(date: string): string {
  const dateObj = new Date(date);
  removeTimezone(dateObj);

  return dateObj.toJSON();
}
